import React from 'react';
import { Modal } from 'antd';
import { Link } from 'react-router-dom';

const CashbackOfferModal = ({ isModalOffer, setIsModalOffer }) => {
    return (
        <Modal
            title="100% Cashback as Reward Points"
            open={isModalOffer}
            onOk={() => setIsModalOffer(false)}
            onCancel={() => setIsModalOffer(false)}
        >
            <p className='mb-2'>
                100% cashback in the form of reward points is applicable to registered users for their first flight booking. Reward points can only be utilized for subsequent hotel and holiday/tour package bookings.
            </p>
            <p className='mb-2'>
                This cashback will be credited to the user's wallet in the superbworldtrip.com portal as "Coins" (1 Point = ₹1).
            </p>
            <p>
                For terms and conditions, please{' '}
                <Link
                    to='/offers'
                    className='text-primary'
                    onClick={(e) => {
                        e.preventDefault();
                        // handleCancelOffer();
                        window.open('/offers', '_blank', 'noopener,noreferrer');
                    }}
                >
                    Click here
                </Link>.
            </p>
        </Modal>
    );
};

export default CashbackOfferModal;
